// Error/Confirmation display messages
export const SELECT_MESSAGE = 'Please select'
export const ENTER_MSG = 'Please enter'
export const SELECT_DATE = 'Please select date'
export const ENTER_MAIL_ID = 'Please enter valid mail ID'
export const NORESULT = 'There are no results to display'
export const FILENAME_REGEX = /['~#%{}+@!$^&=]|\\.\\.|^\\.|\\.$|\\.@|\\.!/
export const DELETE_MESSAGE = 'Are you sure you want to delete this item or items?'
export const NO_CHANGE_MESSAGE = 'No Changes Detected'
export const NOT_SELECT_MESSAGE = 'Please select at least one item to delete.'